import { Group } from '@mantine/core'
import { TimePicker } from '@mantine/dates'
import styles from './TimeRange.module.scss'
import { useState } from 'react'
import cn from 'classnames'

export const TimeRange = ({
   value = ['', ''],
   setValue,
   disabled = false,
}: {
   value: [string, string]
   setValue: (value: [string, string]) => void
   disabled?: boolean
}) => {
   const [startTime, setStartTime] = useState<string>(value[0])
   const [endTime, setEndTime] = useState<string>(value[1])

   return (
      <Group className={cn(styles['time-range'], { 'opacity-50': disabled })} gap={0} wrap='nowrap'>
         <TimePicker
            disabled={disabled}
            value={startTime}
            onChange={(value) => {
               setStartTime(value)
               setValue([value, endTime])
            }}
            withDropdown
            format="12h"
            classNames={{
               input: 'bg-transparent border-none !h-6',
               dropdown: 'bg-black rounded-lg p-2',
            }}
         />
         <TimePicker
            disabled={disabled}
            value={endTime}
            onChange={(value) => {
               setEndTime(value)
               setValue([startTime, value])
            }}
            format="12h"
            withDropdown
            classNames={{
               input: 'bg-transparent border-none !h-6',
               dropdown: 'bg-black rounded-lg p-2',
            }}
         />
      </Group>
   )
}
